import * as React from 'react';
import { connectStateResults } from 'react-instantsearch-core';
import { useIntl } from '@grandvisionhq/state';
import { getResultsByIndex } from '../../Algolia/utils/get-results-by-index.js';
import SortBy from '../../Algolia/components/SortBy/SortBy.js';

const SearchOrderBy = ({ allSearchResults , amountOfHitsLabel , showSortBy , activeIndex , sortIndices  })=>{
    useIntl();
    const suggestions = getResultsByIndex(allSearchResults, (activeIndex === null || activeIndex === void 0 ? void 0 : activeIndex.name) || '');
    const amountOfHits = `${(suggestions === null || suggestions === void 0 ? void 0 : suggestions.nbHits) || 0} ${amountOfHitsLabel}`;
    if (!sortIndices) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-results"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__amount-hits"
    }, amountOfHits), showSortBy && sortIndices && sortIndices.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-by"
    }, /*#__PURE__*/ React.createElement(SortBy, {
        defaultRefinement: sortIndices[0].value,
        items: sortIndices
    })));
};
var SearchOrderBy$1 = connectStateResults(SearchOrderBy);

export { SearchOrderBy, SearchOrderBy$1 as default };
//# sourceMappingURL=SearchOrderBy.js.map
